import {Link as MuiLink, LinkProps as MuiLinkProps} from "@mui/material";
import {colors, fonts} from "../theme";
import {TextVariant} from "./Text";

const textStyles: Record<string, object> = {
  body: {fontFamily: fonts.inter, fontWeight: 400, fontSize: "14px", lineHeight: "22px"},
  "body-medium": {fontFamily: fonts.inter, fontWeight: 500, fontSize: "14px", lineHeight: "22px"},
  "caption-medium": {fontFamily: fonts.inter, fontWeight: 500, fontSize: "12px", lineHeight: "18px"},
};

type LinkProps = Omit<MuiLinkProps, "variant"> & {
  textVariant?: TextVariant;
};

export const Link = ({textVariant = "body", color = colors.grey[800], sx, ...props}: LinkProps) => (
  <MuiLink sx={{...textStyles[textVariant], color, textDecoration: "underline", cursor: "pointer", ...sx}} {...props} />
);
